import { ADMISSION_EMAIL } from '../../types/email';
import type { ApplicationStatus } from '../../types/admissions';
import type { UpcomingRequest } from '../email/useUpcomingEmails';

/** Decisions that email the family, what the email is called, and the confirm button's verb. */
export const DECISION_EMAIL: Partial<Record<ApplicationStatus, { type: string; noun: string; verb: string }>> = {
  Offered: { type: ADMISSION_EMAIL.offered, noun: 'offer', verb: 'Offer' },
  Rejected: { type: ADMISSION_EMAIL.notOffered, noun: 'rejection', verb: 'Reject' },
};

/** The emails a set of decisions causes, for useUpcomingEmails. */
export const decisionEmailRequests = (decisions: Array<{ to: ApplicationStatus; id: string }>): UpcomingRequest[] =>
  (Object.keys(DECISION_EMAIL) as ApplicationStatus[]).map(to => ({
    type: DECISION_EMAIL[to]!.type,
    noun: DECISION_EMAIL[to]!.noun,
    ids: decisions.filter(d => d.to === to).map(d => d.id),
  }));

/** What staff do when an application has no address to email. */
export const NO_EMAIL_HINT = 'Add an email to the application with Edit details.';
